import { FEATURED_BY_FIELD_PROD, FEATURED_BY_FIELD_QA, FEATURED_BY_LANGUAGE_PROD, FEATURED_BY_LANGUAGE_QA, FEATURED_GENERIC_PROD, FEATURED_GENERIC_QA } from '.';
export const isLessonRecommendation = type => {
  return type === 'LESSON';
};
export const userCompletedContentAfterQuiz = (quizCompletionDate, progress) => {
  return Object.values(progress).some(contentProgress => contentProgress.completed && contentProgress.updatedAt > quizCompletionDate);
};
export const getGenericRecommendedSoftware = () => {
  if (window.enviro.isQa()) return FEATURED_GENERIC_QA;
  return FEATURED_GENERIC_PROD;
};
export const getRecommendedSoftwareByField = field => {
  if (window.enviro.isQa()) return FEATURED_BY_FIELD_QA[field];
  return FEATURED_BY_FIELD_PROD[field];
};
export const getRecommendedSoftwareByLanguage = language => {
  if (window.enviro.isQa()) return FEATURED_BY_LANGUAGE_QA[language];
  return FEATURED_BY_LANGUAGE_PROD[language];
};